import React, { useRef, useState } from 'react';

import { makeStyles } from 'tss-react/mui';

import { FEATURE_FLAGS } from 'constants/dictionaries/featureFlags';
import useFeatureFlags from 'hooks/useFeatureFlags/useFeatureFlags';

const useStyles = makeStyles()((theme, { loading }) => ({
  wrapper: {
    position: 'relative',
    transition: '.25s ease .05s',
    border: loading ? 'thin solid transparent' : `thin solid ${theme.palette.grey['300']}`,
  },
  image: {
    transition: '.25s ease .05s',
    opacity: loading ? 0 : 1,
  },
}));

function ImageWithLoader({ src, className = '', alt = '', commitLoad, commitError, ...rest }) {
  const [loading, setLoading] = useState(true);
  const image = useRef();
  const { isEnabled } = useFeatureFlags();
  const onLoad = e => {
    setLoading(false);
    commitLoad(e);
  };
  const onCopy = async () => {
    const isProd = import.meta.env.VITE_ENVIRONMENT === 'production';
    if (isProd && !isEnabled(FEATURE_FLAGS.IMAGE_ASSET_DEBUG_OPEN)) return;
    window.open(src, '_blank').focus();
  };
  const { classes, cx } = useStyles({ loading });
  return (
    <div className={classes.wrapper} onDoubleClick={onCopy}>
      <img
        ref={image}
        alt={alt}
        className={cx(classes.image, className)}
        onError={commitError}
        onErrorCapture={commitError}
        onLoad={onLoad}
        src={src}
        {...rest}
      />
    </div>
  );
}

export default ImageWithLoader;
